import { render, staticRenderFns } from "./SalonInfoBox.vue?vue&type=template&id=83c33824&scoped=true&"
import script from "./SalonInfoBox.vue?vue&type=script&lang=js&"
export * from "./SalonInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./SalonInfoBox.vue?vue&type=style&index=0&id=83c33824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c33824",
  null
  
)

export default component.exports